// Detailed product-portfolio content sourced from traderepubliq.com
export const PRODUCT_DETAILS = {
  "fresh-produce": {
    slug: "fresh-produce",
    title: "Fresh Produce",
    tagline: "Premium fruits and vegetables from certified farms across Africa and South America, delivered with institutional-grade cold-chain precision.",
    certs: ["Cold-chain certified", "GAP compliant", "Pre-cooled logistics"],
    img: "https://images.unsplash.com/photo-1601039641847-7857b994d704?w=1200&q=80",
    items: [
      { name: "Avocados", featured: true, origins: "Kenya, Tanzania, Uganda, Rwanda, Chile", variety: "Hass, Fuerte, Jumbo | Various sizes" },
      { name: "Pineapples", origins: "Kenya, Uganda, Philippines, Ghana", variety: "MD2, Queen | Crown-on/Crown-off" },
      { name: "Vegetables", origins: "Kenya, Ethiopia", variety: "French beans, Snow peas, Sugar snaps" },
    ],
    cta: "Request Product Specifications",
  },
  "pulses-grains": {
    slug: "pulses-grains",
    title: "Pulses & Grains",
    tagline: "Quality legumes and grains sourced directly from origin markets, with rigorous quality control and flexible packaging options.",
    certs: ["Fumigation certified", "Non-GMO available", "Bulk & containerized"],
    img: "https://images.unsplash.com/photo-1599579085809-4edbc35cee01?w=1200&q=80",
    items: [
      { name: "Beans", origins: "Kenya, Uganda, Ethiopia, Argentina", variety: "Kidney, Mung" },
      { name: "Sesame", origins: "Tanzania, Ethiopia, Sudan, Nigeria", variety: "Whitish, Humera | 99%+ purity" },
    ],
    cta: "Request Product Specifications",
  },
  "meat": {
    slug: "meat",
    title: "Meat Products",
    tagline: "Chilled and frozen meat products with full traceability and Halal certification, sourced from verified suppliers across East Africa.",
    certs: ["Halal certified", "-18°C cold chain", "Full traceability"],
    img: "https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?w=1200&q=80",
    items: [
      { name: "Lamb", origins: "Kenya, Tanzania, Ethiopia", variety: "Carcass, Cuts | Halal" },
      { name: "Goat", origins: "Kenya, Tanzania, Uganda, Ethiopia, Pakistan", variety: "Whole carcass, Cuts | Halal" },
    ],
    cta: "Request Product Specifications",
  },
  "coffee": {
    slug: "coffee",
    title: "Coffee",
    tagline: "Commercial grade Arabica & Robusta from East Africa. Roasting takes place in UAE for custom roast profiles and private label solutions.",
    certs: ["Direct trade", "Cupping reports", "Rainforest Alliance"],
    img: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=1200&q=80",
    items: [
      { name: "Kenya AA", origins: "Kenya", variety: "Washed | SCA 85+" },
      { name: "Tanzania Peaberry", origins: "Tanzania", variety: "Washed | SCA 84+" },
      { name: "Uganda Bugisu", origins: "Uganda", variety: "Washed Arabica | SCA 82+" },
      { name: "Robusta", origins: "Uganda, Vietnam", variety: "Screen 18+ | Commercial grade" },
    ],
    cta: "Request Product Specifications",
  },
  "tea": {
    slug: "tea",
    title: "Premium Teas",
    tagline: "Orthodox and CTC teas from premier gardens in East Africa. Tea blending takes place in UAE for custom blends and private label solutions.",
    certs: ["Auction sourced", "Estate direct", "Private label ready"],
    img: "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=1200&q=80",
    items: [
      { name: "Kenya Black", origins: "Kenya", variety: "CTC & Orthodox | BP1, PF1, D1" },
      { name: "Rwanda Tea", origins: "Rwanda", variety: "Orthodox | High-grown" },
      { name: "Uganda Tea", origins: "Uganda", variety: "CTC | Commercial grades" },
      { name: "Specialty Blends", origins: "Multiple", variety: "Custom blending available" },
    ],
    cta: "Request Product Specifications",
  },
  "oilseeds-nuts": {
    slug: "oilseeds-nuts",
    title: "Oilseeds & Nuts",
    tagline: "Premium nuts and oilseeds for industrial and retail applications, with rigorous quality testing and flexible sizing options.",
    certs: ["Aflatoxin tested", "Graded & sorted", "Custom sizing"],
    img: "https://images.unsplash.com/photo-1723466998040-78d7e2ef6d72?w=1200&q=80",
    items: [
      { name: "Cashews", origins: "Kenya, Tanzania, Vietnam", variety: "W180-W450 | Raw & roasted" },
      { name: "Macadamia", origins: "Kenya, South Africa", variety: "Style 0-7 | In-shell & kernel" },
      { name: "Groundnuts", origins: "Malawi, Argentina, India", variety: "Bold, Java | Blanched available" },
      { name: "Sunflower Seeds", origins: "Bulgaria, Argentina, Ukraine", variety: "Confectionery & oilseed" },
    ],
    cta: "Request Product Specifications",
  },
  "private-label": {
    slug: "private-label",
    title: "Private Label",
    tagline: "Your brand, our infrastructure — complete white-label solutions with custom packaging, roasting, blending, and processing capabilities.",
    certs: ["MOQ from 1 MT", "Artwork support", "Compliance ready"],
    img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&q=80",
    items: [
      { name: "Retail Packing", origins: "Various", variety: "Custom packaging 50g–5kg" },
      { name: "Coffee Roasting", origins: "UAE", variety: "Custom roast profiles" },
      { name: "Nut Processing", origins: "UAE, Kenya", variety: "Roasting, flavoring, packing" },
      { name: "Tea Blending", origins: "UAE", variety: "Custom blends & sachets" },
    ],
    cta: "Request Private Label Consultation",
    itemsLabel: "Available Services",
    itemsIntro: "Our private label capabilities for your brand.",
  },
};

export const PRODUCT_ORDER = [
  "fresh-produce",
  "pulses-grains",
  "meat",
  "coffee",
  "tea",
  "oilseeds-nuts",
  "private-label",
];
